<template>
    <div>
        <p>Sorry the error ocurred, did you set <i>report</i> GET parameter?</p>
    </div>
</template>

<script>
export default {
    name: 'ErrorMessage'
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/ErrorMessage.vue